import React, { ReactElement, FC } from 'react'
import { Button } from 'antd'

type ButtonProps = React.ComponentProps<typeof Button>

export const HeavyOutlineButton: FC<ButtonProps> = ({
  children,
  style,
  ...rest
}): ReactElement => (
  <Button
    style={{
      ...style,
      ...{ fontSize: 14, fontWeight: 600, borderColor: '#595959' },
    }}
    {...rest}
  >
    {children}
  </Button>
)
